import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';

import { DropdownOptionType } from '../types/dropdown';
import { ProductsModel } from '../interface/products';
import { isTrueAll, isOneConditionTrue, isFalseAll } from '../utils/conditions';
import { DROPDOWN_DEFAULT_VALUE } from '../constants/dropdown';

export const useManualsAndGuidesFilter = (
  categoryOptions: DropdownOptionType[],
  products: ProductsModel[]
) => {
  const [brandFilter, setBrandFilter] = useState<string>(
    DROPDOWN_DEFAULT_VALUE
  );
  const [categoryFilter, setCategoryFilter] = useState<string>(
    DROPDOWN_DEFAULT_VALUE
  );
  const [productOptionsList, setProductOptionsList] = useState<any>([]);

  const setDropdownCategoryOptions = categoryOptions.filter(
    (category: DropdownOptionType) =>
      [category.brand, DROPDOWN_DEFAULT_VALUE].includes(brandFilter)
  );

  const filteredDropdownOptions = isEqual(brandFilter, DROPDOWN_DEFAULT_VALUE)
    ? categoryOptions
    : [categoryOptions[0], ...setDropdownCategoryOptions];

  useEffect(() => {
    if (!isEqual(brandFilter, DROPDOWN_DEFAULT_VALUE))
      setCategoryFilter(filteredDropdownOptions[0].optionValue);
  }, [brandFilter]);

  useEffect(() => {
    let filteredProductsList = true;
    const filteredProducts = products.filter((product) => {
      if (isTrueAll([brandFilter, categoryFilter], DROPDOWN_DEFAULT_VALUE))
        filteredProductsList = true;
      if (
        isOneConditionTrue(brandFilter, categoryFilter, DROPDOWN_DEFAULT_VALUE)
      )
        filteredProductsList = isEqual(product.attributes.Brand, brandFilter);
      if (
        isOneConditionTrue(categoryFilter, brandFilter, DROPDOWN_DEFAULT_VALUE)
      )
        filteredProductsList = isEqual(
          product.attributes.Category,
          categoryFilter
        );
      if (isFalseAll([brandFilter, categoryFilter], DROPDOWN_DEFAULT_VALUE))
        filteredProductsList =
          isEqual(product.attributes.Brand, brandFilter) &&
          isEqual(product.attributes.Category, categoryFilter);
      return filteredProductsList;
    });

    const productOptions = filteredProducts.map((product) => {
      return {
        brand: product.attributes.Brand,
        optionLabel: product.attributes.ModelName,
        optionValue: product.attributes.ModelName
      };
    });

    productOptions.unshift({
      brand: DROPDOWN_DEFAULT_VALUE,
      optionLabel: 'Select product',
      optionValue: DROPDOWN_DEFAULT_VALUE
    });

    setProductOptionsList(productOptions);
  }, [brandFilter, categoryFilter]);

  return {
    brandFilter,
    categoryFilter,
    filteredDropdownOptions,
    productOptionsList,
    setBrandFilter,
    setCategoryFilter
  };
};
